<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import diasLaboralesAPI from "@/services/standards/diasLaborales/diasLaboralesAPI";
import { dateFormatYear } from "@/utils/helpers/format";
import ItemAPI from "@/services/items/itemsAPI";
import CheckModal from "@/components/CheckModal";

/**
 * Form elements component
 */
export default {
  page: {
    title: "Configurar días laborables",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    CheckModal,
    Layout,
    Style,
    PageHeader,
  },
  data() {
    return {
      title: "3.3.6 Configurar días laborables",
      items: [
        {
          text: "Estandares",
          href: "/forms/estandares",
        },
        {
          text: "Medición del ausentismo por causa médica",
          href: `/forms/estandares/${this.$store.getters["company/getCompany"].id || null
            }/medicion-ausentismo-registro`,
        },
        {
          text: "Configurar días laborables",
          href: `/forms/estandares/${this.$store.getters["company/getCompany"].id || null
            }/dias-laborales`,
        },
        {
          text: "Ver",
          active: true,
        },
      ],

      itemData: null,
      item: null,
      search: "",
      years: [],
      lista: [],
      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,

      dias: {
        year: null,
        companies_id: this.$store.getters["company/getCompany"].id || null,

        data: [
          {
            cuantity_days: 0,
            mounth: 1,
          },
          {
            cuantity_days: 0,
            mounth: 2,
          },
          {
            cuantity_days: 0,
            mounth: 3,
          },
          {
            cuantity_days: 0,
            mounth: 4,
          },
          {
            cuantity_days: 0,
            mounth: 5,
          },
          {
            cuantity_days: 0,
            mounth: 6,
          },
          {
            cuantity_days: 0,
            mounth: 7,
          },
          {
            cuantity_days: 0,
            mounth: 8,
          },
          {
            cuantity_days: 0,
            mounth: 9,
          },
          {
            cuantity_days: 0,
            mounth: 10,
          },
          {
            cuantity_days: 0,
            mounth: 11,
          },
          {
            cuantity_days: 0,
            mounth: 12,
          },
        ],
      },
    };
  },
  methods: {
    fetch() {
      this.$refs.paginator.query();
    },

    getItemData() {
      ItemAPI.getItems(40)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"]
              .company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;

      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role =
            role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;

        // Know if the user has the permission indicated
        const enabled = permissions.find(
          (permission) => permission.name === name
        );

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged

      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 40)
        .then((response) => {
          this.item = response || null;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getList() {
      diasLaboralesAPI
        .get(this.companyID)
        .then((response) => {
          let medicion = response.data;
          this.lista = medicion;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getdias() {
      diasLaboralesAPI
        .getShow(this.companyID, this.$route.params.id)
        .then((response) => {
          this.loading1 = false;
          this.dias.year = this.$route.params.id;
          this.dias.data[0].cuantity_days = response.data[0].cuantity_days;
          this.dias.data[1].cuantity_days = response.data[1].cuantity_days;
          this.dias.data[2].cuantity_days = response.data[2].cuantity_days;
          this.dias.data[3].cuantity_days = response.data[3].cuantity_days;
          this.dias.data[4].cuantity_days = response.data[4].cuantity_days;
          this.dias.data[5].cuantity_days = response.data[5].cuantity_days;
          this.dias.data[6].cuantity_days = response.data[6].cuantity_days;
          this.dias.data[7].cuantity_days = response.data[7].cuantity_days;
          this.dias.data[8].cuantity_days = response.data[8].cuantity_days;
          this.dias.data[9].cuantity_days = response.data[9].cuantity_days;
          this.dias.data[10].cuantity_days = response.data[10].cuantity_days;
          this.dias.data[11].cuantity_days = response.data[11].cuantity_days;
        })
        .catch((error) => {
          console.log(error);
          this.loading1 = false;
        });
    },

    dateConvert(date) {
      return dateFormatYear(date);
    },

    goBack() {
      this.$router.go(-1);
    },

    rangeYear() {
      const max = 2040;
      const min = 2019;

      for (let i = min; i <= max; i++) {
        this.years.push(i);
      }
      return this.years
    },

    goPage(page) {
      window.location.href = page;
    },
  },

  mounted() {
    this.rangeYear();
    this.getdias();
    this.getList();
    this.getItems();
    this.getItemData();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12 m-0 p-0">
        <div class="card">
          <div class="card-body">
            <div class="row px-3">
              <div class="col-12 text-right m-b-0">
                <div class="btn btn-secondary m-l-5 ml-1" id="back" @click="goBack">
                  <i class="fas fa-arrow-left"></i>
                </div>
                <b-tooltip target="back" placement="left"> Volver </b-tooltip>
              </div>
            </div>

            <hr />

            <div class="px-4">
              <h4>Configurar días laborables</h4>
            </div>
            <form class="row pt-3 pl-2" @submit.prevent="save">
              <b-form-group id="cycle" label-for="cycle" class="col-md-3 px-4" label="Seleccione el año">
                <b-form-select disabled class="col-md-8 form-control" v-model="dias.year">
                  <b-form-select-option v-for="item in years" :value="item" v>
                    {{ item }}
                  </b-form-select-option>
                </b-form-select>
              </b-form-group>
              <div class="col-6 px-4 mt-2" v-if="getRole('Consultar')">
                <table class="table-sm pt-2 table border-bottom divide-y divide-gray-200 table-bordered rounded">
                  <thead class="bg-primary text-light">
                    <tr>
                      <th class="text-center align-middle">Mes</th>
                      <th class="text-center align-middle">Días laborales</th>
                    </tr>
                  </thead>
                  <tbody class="">
                    <tr>
                      <td class="bg-primary text-light text-center align-middle">
                        <b>Enero</b>
                      </td>
                      <td class="text-center align-middle d-flex justify-content-center">
                        <b-form-input class="col-6" type="number" :value="this.dias.data[0].cuantity_days" disabled
                          v-model="dias.data[0].cuantity_days" min="0" max="100"></b-form-input>
                      </td>
                    </tr>
                    <tr>
                      <td class="bg-primary text-light text-center align-middle">
                        <b>Febrero</b>
                      </td>
                      <td class="text-center align-middle d-flex justify-content-center">
                        <b-form-input class="col-6" type="number" disabled v-model="dias.data[1].cuantity_days" min="0"
                          max="100"></b-form-input>
                      </td>
                    </tr>
                    <tr>
                      <td class="bg-primary text-light text-center align-middle">
                        <b>Marzo</b>
                      </td>
                      <td class="text-center align-middle d-flex justify-content-center">
                        <b-form-input class="col-6" type="number" disabled v-model="dias.data[2].cuantity_days" min="0"
                          max="100"></b-form-input>
                      </td>
                    </tr>
                    <tr>
                      <td class="bg-primary text-light text-center align-middle">
                        <b>Abril</b>
                      </td>
                      <td class="text-center align-middle d-flex justify-content-center">
                        <b-form-input class="col-6" type="number" disabled v-model="dias.data[3].cuantity_days" min="0"
                          max="100"></b-form-input>
                      </td>
                    </tr>
                    <tr>
                      <td class="bg-primary text-light text-center align-middle">
                        <b>Mayo</b>
                      </td>
                      <td class="text-center align-middle d-flex justify-content-center">
                        <b-form-input class="col-6" type="number" disabled v-model="dias.data[4].cuantity_days" min="0"
                          max="100"></b-form-input>
                      </td>
                    </tr>
                    <tr>
                      <td class="bg-primary text-light text-center align-middle">
                        <b>Junio</b>
                      </td>
                      <td class="text-center align-middle d-flex justify-content-center">
                        <b-form-input class="col-6" type="number" disabled v-model="dias.data[5].cuantity_days" min="0"
                          max="100"></b-form-input>
                      </td>
                    </tr>
                    <tr>
                      <td class="bg-primary text-light text-center align-middle">
                        <b>Julio</b>
                      </td>
                      <td class="text-center align-middle d-flex justify-content-center">
                        <b-form-input class="col-6" type="number" disabled v-model="dias.data[6].cuantity_days" min="0"
                          max="100"></b-form-input>
                      </td>
                    </tr>
                    <tr>
                      <td class="bg-primary text-light text-center align-middle">
                        <b>Agosto</b>
                      </td>
                      <td class="text-center align-middle d-flex justify-content-center">
                        <b-form-input class="col-6" type="number" disabled v-model="dias.data[7].cuantity_days" min="0"
                          max="100"></b-form-input>
                      </td>
                    </tr>
                    <tr>
                      <td class="bg-primary text-light text-center align-middle">
                        <b>Septiembre</b>
                      </td>
                      <td class="text-center align-middle d-flex justify-content-center">
                        <b-form-input class="col-6" type="number" disabled v-model="dias.data[8].cuantity_days" min="0"
                          max="100"></b-form-input>
                      </td>
                    </tr>
                    <tr>
                      <td class="bg-primary text-light text-center align-middle">
                        <b>Octubre</b>
                      </td>
                      <td class="text-center align-middle d-flex justify-content-center">
                        <b-form-input class="col-6" type="number" disabled v-model="dias.data[9].cuantity_days" min="0"
                          max="100"></b-form-input>
                      </td>
                    </tr>
                    <tr>
                      <td class="bg-primary text-light text-center align-middle">
                        <b>Noviembre</b>
                      </td>
                      <td class="text-center align-middle d-flex justify-content-center">
                        <b-form-input class="col-6" type="number" disabled v-model="dias.data[10].cuantity_days" min="0"
                          max="100"></b-form-input>
                      </td>
                    </tr>
                    <tr>
                      <td class="bg-primary text-light text-center align-middle">
                        <b>Diciembre</b>
                      </td>
                      <td class="text-center align-middle d-flex justify-content-center">
                        <b-form-input class="col-6" type="number" disabled v-model="dias.data[11].cuantity_days" min="0"
                          max="100"></b-form-input>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- end col -->
            </form>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>
